import { setAIVoices } from './ai-voices-slices';

import type { AIVoice } from 'js/src/client';
import { ApiService } from 'js/src/client';
import { getCanUseAIVoiceover } from 'js/src/data/account';
import { getAIVoiceById } from 'js/src/data/ai-voices-and-avatars/ai-voices/ai-voices-selectors';
import { showModal } from 'js/src/data/modals/modals-actions';
import { LOCKED_FEATURES, MODAL_IDS } from 'js/src/data/modals/modals-types';
import { ErrorReporter } from 'js/src/libs/error-reporter';
import type { AppDispatch, RootState } from 'js/src/libs/RootState';
import { isApiErrorWithProperty } from 'js/src/types';

export const fetchDefaultAIVoice = () => {
    return async (dispatch: AppDispatch, getState: () => RootState) => {
        if (!getCanUseAIVoiceover(getState())) {
            return null;
        }

        try {
            const response = await ApiService.aiVoiceV2DefaultVoiceRetrieve();
            const voice = response.data;
            dispatch(setAIVoices([voice]));
            return voice;
        } catch (error) {
            ErrorReporter.capture(error);
            return null;
        }
    };
};

export const ensureAIVoiceLoaded = (slug: string, force = false) => {
    return async (dispatch: AppDispatch, getState: () => RootState): Promise<AIVoice | null> => {
        if (!force) {
            const existing = getAIVoiceById(getState(), slug);
            if (existing) {
                return existing;
            }
        }

        try {
            const response = await ApiService.aiVoiceV2RetrieveBySlugQuery({
                query: { slug },
            });
            dispatch(setAIVoices([response.data]));
            return response.data;
        } catch (error) {
            ErrorReporter.capture(error, { level: 'warning' });
            return null;
        }
    };
};

export const fetchAIVoicesTastingMenu = () => {
    return async (dispatch: AppDispatch) => {
        try {
            const response = await ApiService.aiVoiceV2TastingMenuList();
            dispatch(setAIVoices(response.data));
            return true;
        } catch (error) {
            ErrorReporter.capture(error);
            return false;
        }
    };
};

export const isPremiumVoiceNotAvailableError = (error: unknown) =>
    isApiErrorWithProperty(error, 'error') && error.body?.error === 'premium_voice_not_available';

export const showUpgradeIfVoiceNeedsPremiumPlan = (error: unknown, dispatch: AppDispatch) => {
    if (!isPremiumVoiceNotAvailableError(error)) {
        return false;
    }
    dispatch(
        showModal({
            modal_id: MODAL_IDS.FEATURE_LOCK,
            modal_context: { featureName: LOCKED_FEATURES.PREMIUM_AI_VOICE },
        }),
    );
    return true;
};
